export default __webpack_public_path__ + "static/media/pfp2.77db00e7.png";